import {AfterContentInit, Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {MatSnackBar} from "@angular/material/snack-bar";
import { WebcamModule } from 'ngx-webcam';
import { NgIf } from '@angular/common';
import { NgxResizeObserverModule } from 'ngx-resize-observer';

@Component({
    selector: 'app-debug',
    templateUrl: './debug.component.html',
    styleUrls: ['./debug.component.scss'],
    standalone: true,
    imports: [NgxResizeObserverModule, NgIf, WebcamModule]
})
export class DebugComponent implements OnInit {

  connectionState?: string ;
  width: number = 0 ;
  height: number = 0 ;

  @ViewChild('container') container? : ElementRef;

  constructor(
    private _snackBar: MatSnackBar
  ) {

  }

  @HostListener('window:focus', ['$event'])
  onFocus(event: FocusEvent): void {
    this.onRejoin();
  }

  onRejoin() {
    this._snackBar.open("Welcome back!", undefined, {duration: 2000}) ;
  }

  ngOnInit(): void {
    const roomId = '65d6a56b8de2a5275f8e28fc' ;

    setTimeout(() => {
      this.dimensionVideo() ;
    }) ;

    //TODO: debug iot connection
      /*
    this._stomp.connectionState$.subscribe((state: RxStompState) => {

      if (state == RxStompState.CLOSED) {
        this.connectionState = 'CLOSED' ;
        this._snackBar.open("Stream closed", undefined, {duration: 3000}) ;
      }

      if (state == RxStompState.CONNECTING) {
        this.connectionState = 'CONNECTING' ;
        this._snackBar.open("Stream connecting", undefined, {duration: 3000}) ;
      }

      if (state == RxStompState.OPEN) {
        this.connectionState = 'OPEN' ;
        this._snackBar.open("Stream open", undefined, {duration: 3000}) ;
      }
    })

    this._stomp.watch(`/topic/rooms/${roomId}`).subscribe((message: any) => {
      this._snackBar.open(message, undefined, {duration: 3000});
    });
    */
  }

  handleContainerResize(event:any) {
    this._snackBar.open(`w:${event.contentRect.width}, h:${event.contentRect.height}`) ;
    this.dimensionVideo();
  }


  dimensionVideo() {
    if (this.container) {
      this.width = this.container.nativeElement.offsetWidth;
      this.height = this.container.nativeElement.offsetHeight;
      console.log(this.width, this.height);
    } else {
      console.log("No container found") ;
    }

  }

}
